import React, { Component } from 'react'
import {connect} from "react-redux"
import {OverlayView} from "react-google-maps";

const getPixelPositionOffset = (width, height) => ({
    x: -(width / 2),
    y: -(height / 2),
})

const middlePoint = (pickup, drop) => {
    return {
        lat: (pickup.lat + drop.lat)/2,
        lng: (pickup.lng + drop.lng)/2
    }
}

class EstimatePrice extends Component {

    total(){
        const {estimate, insurance, donation, coupon} = this.props;
        const price = estimate.data.total_amount;
        const extra = insurance + donation;
        let result;
        if(coupon.id){
            const percent = (coupon.offer / 100).toFixed(2);
            const disCountWithOffer = (price * percent);
            if(disCountWithOffer < coupon.max_amount){
                result = price - disCountWithOffer 
            } else {
                result = price - coupon.max_amount
            }
        } else {
            result =  price;
        }
        return result + extra;
    }

    render() {
        const {estimate, marker} = this.props;
        const {pickup, drop} = marker;
        return (
            pickup && drop && estimate.data && !estimate.fetching ?
            <OverlayView
                position={middlePoint(pickup, drop)}
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                getPixelPositionOffset={getPixelPositionOffset}
            >
                <button className="estimate-price">
                    ETP : ₹ {this.total()}
                </button>
            </OverlayView> : null
        )
    }
}

const mapStateToProps = (state) => ({
    marker: state.bookingLoc,
    estimate: state.estimate,
    insurance: state.insAmt.insurance,
    donation: state.insAmt.donation,
    coupon: state.coupon
})

export default connect(mapStateToProps)(EstimatePrice)

